export default {
  SECTION_TYPE_UNKNOWN: 0,
  SECTION_TYPE_ORGANIC: 1,
  SECTION_TYPE_PREMIUM: 2,
};



// WEBPACK FOOTER //
// ./app/tracking/SectionTypes.js